import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate, useLocation } from 'react-router-dom'

const IDLE_TIMEOUT = 5 * 60 * 1000; // 5 minutes
const IDLE_EXCLUDED_PATHS = ["/register"];


function IdleTimeout() {
    const navigate = useNavigate();
    const location = useLocation();
  const handleOnIdle = () => {
    if (IDLE_EXCLUDED_PATHS.includes(location.pathname)) return;
    navigate("/login")
  };

  useIdleTimer({
    timeout: IDLE_TIMEOUT,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return null; // No UI needed
}

export default IdleTimeout;
